// extracted by mini-css-extract-plugin
export var layoutContainer = "_9o-0";
export var layoutContainerNoRounding = "_9o-6";
export var layoutContainerOpen = "_9o-5";
export var layoutContainerResizing = "_9o-1";
export var mainContent = "_9o-2";
export var resizeDivider = "_9o-3";
export var slidePanel = "_9o-4";